export const gallery = [
  {
    name: "MONEY EXPO INDIA 2024",
    date: "Aug 17,2024",
    loc: "Mumbai, India",
    source: "./v2/gallery/pic1.jpeg",
  },
  {
    name: "Google Cloud Community Days",
    date: "Aug 17,2024",
    loc: "Kolkata, India",
    source: "./v2/gallery/pic2.jpeg",
  },
  {
    name: "UX India Kolkata Meetup 2024",
    date: "Aug 03,2024",
    loc: "Kolkata, India",
    source: "./v2/gallery/pic3.jpeg",
  },
  {
    name: "India Blockchain Tour 3.0",
    date: "July 13,2024",
    loc: "Delhi, India",
    source: "./v2/gallery/pic4.png",
  },
  {
    name: "Business Meet with Dr. h. c. Charles Singh",
    date: "May 22,2024",
    loc: "Bangkok, Thailand",
    source: "./v2/gallery/pic5.png",
  },
  {
    name: "Business Meet with Innovative Software Consultancy",
    date: "May 20,2024",
    loc: "Bangkok, Thailand",
    source: "./v2/gallery/pic6.jpeg",
  },
  {
    name: "ETH Tokyo 2024",
    date: "Aug 26,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic7.svg",
  },
  {
    name: "ETH Tokyo 2024",
    date: "Aug 26,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic8.svg",
  },
  {
    name: "ETH Tokyo 2024",
    date: "Aug 26,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic9.svg",
  },
  {
    name: "ETH Tokyo 2024",
    date: "Aug 26,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic10.svg",
  },
  {
    name: "ETH Tokyo 2024",
    date: "Aug 26,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic11.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 27,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic13.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 27,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic14.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 28,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic12.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 28,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic15.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 28,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic16.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 28,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic17.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 28,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic18.svg",
  },
  {
    name: "WEB X 2024",
    date: "Aug 29,2024",
    loc: "Tokyo , Japan",
    source: "./v2/gallery/pic19.svg",
  },
];
